import {
  ApiURLFactory,
  axiosPost,
  IApiResponseBase,
  useApiResponse,
} from '../../api'

export interface IWebPushApiTokenPost extends IApiResponseBase {
  success: boolean
}

export async function useApiFirebasePushTokenPost(
  token: string
): Promise<boolean> {
  const urlObject = ApiURLFactory.track('firebase/push/token')
  const formData = new FormData()
  formData.append('token', token)
  const responseRaw = await axiosPost<IWebPushApiTokenPost>(urlObject, formData)
  const responseState = useApiResponse(responseRaw)
  return responseState.isOk
}
